import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Event, EventService } from 'api';

export const ticketingQuantitiesEventResolver: ResolveFn<Event> = (route) => {
  return inject(EventService).getEvent(route.params['eventCode']);
};
